import { Eye } from 'lucide-preact'
import { memo } from 'preact/compat'
import type { AnalyticsMetricDto } from '@/types/analytics'
import { AnalyticsStatTile } from './AnalyticsStatTile'

interface Props {
  metric: AnalyticsMetricDto | null
  loading: boolean
  error: string | null
}

export const LandingPageViewsStatTile = memo(({ metric, loading, error }: Props) => (
  <AnalyticsStatTile
    title={<><span className="block">Landing Page</span><span className="block">Views</span></>}
    icon={<Eye className="w-5 h-5 text-primary-600 dark:text-primary-400" />}
    metric={metric}
    loading={loading}
    error={error}
  />
))
